import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export function DashboardHeader({
  title,
  buttonText,
  buttonRoute,
  showBackButton
}) {
  const location = useLocation();
  const isAnalytics = location.pathname === "/analytics-dashboard";
  const [hovered, setHovered] = useState(false);

  const displayTitle = title ?? "Welcome to Dashboard";
  const displayButtonText = buttonText ?? (isAnalytics ? "Back to Dashboard" : "Analytics Dashboard");
  const displayButtonRoute = buttonRoute ?? (isAnalytics ? "/dashboard" : "/analytics-dashboard");
  const displayShowBackButton = showBackButton ?? isAnalytics;

  // Both buttons — same standard theme purple style
  const sharedBase = {
    background: "#6f42c1",
    color: "#fff",
    border: "1px solid #5f33b1",
    fontWeight: "600",
    borderRadius: "8px",
    padding: "10px 22px",
    fontSize: "0.92rem",
    letterSpacing: "0.02em",
    boxShadow: "0 2px 6px rgba(111, 66, 193, 0.18)",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    textDecoration: "none",
  };

  const sharedHover = {
    background: "#5a32a3",
    borderColor: "#4a258c",
    boxShadow: "0 3px 10px rgba(111, 66, 193, 0.25)",
    transform: "translateY(-1px)",
  };

  const config = { base: sharedBase, hover: sharedHover };
  const combinedStyle = hovered
    ? { ...config.base, ...config.hover }
    : config.base;

  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h2 className="card-label mb-0">
        {displayTitle}
      </h2>
      <Link
        to={displayButtonRoute}
        style={combinedStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {displayShowBackButton && (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        )}
        {displayButtonText}
      </Link>
    </div>
  );
}
